export const STORAGE_KEY_PHONE = 'patientPhone';
export const STORAGE_KEY_PHONE_DIAL = 'patientPhoneDial';
export const DEFAULT_PHONE_DIAL = '55';

export const PRESET_COUNTRY_DIALS = [
  { dial: '55', label: 'Brasil' },
  { dial: '351', label: 'Portugal' },
  { dial: '1', label: 'EUA / Canada' },
  { dial: '54', label: 'Argentina' },
  { dial: '598', label: 'Uruguai' },
  { dial: '595', label: 'Paraguai' },
  { dial: '56', label: 'Chile' },
  { dial: '57', label: 'Colombia' },
  { dial: '52', label: 'Mexico' },
  { dial: '49', label: 'Alemanha' },
  { dial: '33', label: 'Franca' },
  { dial: '39', label: 'Italia' },
  { dial: '34', label: 'Espanha' },
  { dial: '44', label: 'Reino Unido' },
];

const PRESET_SET = new Set(PRESET_COUNTRY_DIALS.map((o) => o.dial));

/** Códigos de área em uso no Brasil (plano de numeração da Anatel). */
const BRAZIL_DDDS = new Set([
  '11', '12', '13', '14', '15', '16', '17', '18', '19',
  '21', '22', '24', '27', '28',
  '31', '32', '33', '34', '35', '37', '38',
  '41', '42', '43', '44', '45', '46', '47', '48', '49',
  '51', '53', '54', '55',
  '61', '62', '63', '64', '65', '66', '67', '68', '69',
  '71', '73', '74', '75', '77', '79',
  '81', '82', '83', '84', '85', '86', '87', '88', '89',
  '91', '92', '93', '94', '95', '96', '97', '98', '99',
]);

export function isValidBrazilDdd(nationalDigits) {
  return BRAZIL_DDDS.has(String(nationalDigits || '').replace(/\D/g, '').slice(0, 2));
}

export function isPresetDial(d) {
  return PRESET_SET.has(String(d || ''));
}

function normalizeDialDigits(raw) {
  const d = String(raw || '').replace(/\D/g, '');
  if (!d) return DEFAULT_PHONE_DIAL;
  if (!/^[1-9]\d{0,2}$/.test(d)) return DEFAULT_PHONE_DIAL;
  if (d.length > 3) return DEFAULT_PHONE_DIAL;
  return d;
}

export function readPatientPhoneDial() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PHONE_DIAL) || sessionStorage.getItem(STORAGE_KEY_PHONE_DIAL);
    if (raw == null || raw === '') return DEFAULT_PHONE_DIAL;
    return normalizeDialDigits(raw);
  } catch (e) {
    return DEFAULT_PHONE_DIAL;
  }
}

export function writePatientPhoneDial(dialDigits, opts) {
  const omitIfBrazil = opts == null || opts.omitIfBrazil !== false;
  const d = normalizeDialDigits(dialDigits);
  try {
    if (omitIfBrazil && d === DEFAULT_PHONE_DIAL) {
      localStorage.removeItem(STORAGE_KEY_PHONE_DIAL);
      sessionStorage.removeItem(STORAGE_KEY_PHONE_DIAL);
      return;
    }
    localStorage.setItem(STORAGE_KEY_PHONE_DIAL, d);
    sessionStorage.setItem(STORAGE_KEY_PHONE_DIAL, d);
  } catch (e) {}
}

export function readPatientPhoneNationalDigits() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PHONE) || sessionStorage.getItem(STORAGE_KEY_PHONE) || '';
    return String(raw).replace(/\D/g, '');
  } catch (e) {
    return '';
  }
}

export function composePatientPhoneE164Digits(nationalDigits, dialDigits) {
  const dial = normalizeDialDigits(dialDigits);
  const nat = String(nationalDigits || '').replace(/\D/g, '');
  if (!nat) return '';
  return (dial + nat).slice(0, 15);
}

export function readPatientPhoneFullE164Digits() {
  return composePatientPhoneE164Digits(readPatientPhoneNationalDigits(), readPatientPhoneDial());
}
